export enum FieldType {
    Ackerbau = "ArableFarming",
    Futterbau = "ForageProduction"
}
